export enum NaturezaMovimentacaoEnum {
    Entrada = 1,
    Saida = 2
}
